<!-- MODAL generarIPT -->
<div mdbModal #generarIPT="mdb-modal" class="modal fade" style="overflow-y: auto;" id="basicExample" tabindex="-1"
  role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-fluid" style="max-width: 80%;" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Generar IPT - Vendedor
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="generarIPT.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <form [formGroup]='formHeader' novalidate>
        <div class="modal-body">

          <div class="row filtros-body">
            <div class="col" style="max-width: 150px">
              <div class="md-form">
                <input value="" [readonly]="true" type="text" id="rutvende" class="form-control" placeholder="9.999.999-9" required
                  #rutvende formControlName="rutVendedor" formatRut />
                <label for="rutvende">RUT vendedor</label>
                <!-- <div *ngIf="
                      formHeader.get('rutVendedor').invalid &&
                      (formHeader.get('rutVendedor').dirty ||
                      formHeader.get('rutVendedor').touched)
                  ">
                  <mdb-error *ngIf="formHeader.get('rutVendedor').hasError('required')">
                    Ingrese rut vendedor
                  </mdb-error>
                </div> -->
              </div>
            </div>
            <div class="col d-flex" style="max-width: 300px; margin-top: 1%;">
              <!-- <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                (click)="openModalSeleccionarVendedor()">
                <mdb-icon fas icon="search"></mdb-icon>
              </button> -->
              <h6 class="text-info" style="display: contents">
                {{ vendedorSeleccionado?.nombre }}
              </h6>
            </div>
          </div>

          <!-- Nav tabs -->
          <mdb-tabset #staticTabs [buttonClass]="'md-tabs tabs-primary tabs-2'" [justified]="true"
            [contentClass]="'card'">
            <!--Panel 1-->
            <mdb-tab heading="Automático">
              <h6>IPT</h6>

              <app-ipt-panel (messageEvent)="receiveMessage($event)"></app-ipt-panel>

            </mdb-tab>
            <!--Panel 2-->
            <mdb-tab heading="Manual">
              <div class="row filtros-body">
                <div class="table-responsive">
                  <table class="table table-striped table-hover table-sm align-middle">
                    <thead class="grey lighten-2">
                      <tr>
                        <th scope="col">RUT Cliente</th>
                        <th scope="col">
                          Nombre Cliente
                        </th>
                        <th scope="col">L</th>
                        <th scope="col">M</th>
                        <th scope="col">M</th>
                        <th scope="col">J</th>
                        <th scope="col">V</th>
                        <th scope="col">S</th>
                        <th scope="col">D</th>
                      </tr>
                    </thead>
                    <tbody *ngFor="let item of listaClientes; let i = index;" >

                      <tr>

                        <td>{{ this.rutService.AgregarDV(item.rut) | rut}}</td>
                        <td>{{item.nombre}}</td>
                        <td>
                          <mdb-checkbox [checked]="item.lunes" (change)="onChangeL($event,i, item)"></mdb-checkbox>
                        </td>
                        <td>
                          <mdb-checkbox [checked]="item.martes" (change)="onChangeM($event,i, item)"></mdb-checkbox>
                        </td>
                        <td>
                          <mdb-checkbox [checked]="item.miercoles" (change)="onChangeMi($event,i, item)"></mdb-checkbox>
                        </td>
                        <td>
                          <mdb-checkbox [checked]="item.jueves" (change)="onChangeJ($event,i, item)"></mdb-checkbox>
                        </td>
                        <td>
                          <mdb-checkbox [checked]="item.viernes" (change)="onChangeV($event,i, item)"></mdb-checkbox>
                        </td>
                        <td>
                          <mdb-checkbox [checked]="item.sabado" (change)="onChangeS($event,i, item)"></mdb-checkbox>
                        </td>
                        <td>
                          <mdb-checkbox [checked]="item.domingo" (change)="onChangeD($event,i, item)"></mdb-checkbox>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </mdb-tab>

          </mdb-tabset>






        </div>
      </form>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="generarIPT.hide()"
          mdbWavesEffect>
          Cerrar
        </button>
        <button type="button" class="btn btn-secondary waves-light" mdbWavesEffect (click)="generarIPTVendedor()">
          Generar
        </button>
      </div>
    </div>
  </div>
</div>

<!-- MODAL seleccionarVendedor -->
<app-modal-seleccionar-vendedor [multiple]="false" queryType="ONLY_RUT"
  (onSelectSingle)="onVendedorSeleccionado($event)" (onNotFound)="onVendedorNoEncontrado()">
</app-modal-seleccionar-vendedor>
